module.exports = __webpack_public_path__ + "img/accomodation-outdoor.ad0a34c4.webp";